import { SkeletonTheme } from "react-loading-skeleton";
import { BrowserRouter, Navigate, Route, Routes } from "react-router";
import { ToastContainer } from "react-toastify";

import { Dev } from "pages/dev/dev";
import { Portfolio, PortfolioAssets, PortfolioPoints } from "pages/portfolio";
import { PreDeposit } from "pages/pre-deposit";
import { Ref } from "pages/ref";
import { RqProvider } from "shared/providers/rq";
import { WagmiProvider } from "shared/providers/wagmi";

export const App = () => {
  return (
    <WagmiProvider>
      <RqProvider>
        <SkeletonTheme baseColor="#121212" highlightColor="#212121">
          <BrowserRouter>
            <Routes>
              <Route path="/dev" element={<Dev />} />
              <Route path="/" element={<PreDeposit />} />
              <Route path="/ref/:ref" element={<Ref />} />
              <Route path="/portfolio" element={<Portfolio />}>
                <Route index element={<PortfolioAssets />} />
                <Route
                  index
                  path="/portfolio/points"
                  element={<PortfolioPoints />}
                />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </SkeletonTheme>
        <ToastContainer
          closeButton={false}
          icon={false}
          theme="dark"
          className="z-50"
          position="bottom-center"
        />
      </RqProvider>
    </WagmiProvider>
  );
};
